module.exports = __webpack_public_path__ + "static/media/1174654_742563652443055_766764419_n.95125190.jpg";